//-----------Basic imports----------------------------
import styles from './Notifications.module.scss'

//-----------Libraries----------------------------
import { Formik } from 'formik'

//-------------Validations-----------------------------
import VALIDATIONS from '../../../validation'

//------------Components-----------------------------
import { Button, Input, Loader } from '../../../components'
import { useEffect, useState } from 'react'
import NotificationsApi from '../../../APIs/notifications'
import CustomMultiSelectInput from '../../../components/CustomMultiSelectInput'
import { useDispatch } from 'react-redux'
import { showAlertAction } from "../../../redux/actions/alertActions";
import { useHistory } from 'react-router-dom';

const AddNotifications = () => {
  const dispatch = useDispatch()
  const history = useHistory();
  const [isSelectAllUser, setIsSelectAllUser] = useState(false)
  const [searchTerm, setSearchTerm] = useState('')
  const [currentPage, setCurrentPage] = useState(1)
  const [limit] = useState(100)
  const [hasMore, setHasMore] = useState(true)
  const [options, setOptions] = useState([])
  const [user, setUser] = useState([])
  const [selectedIds, setSelectedIds] = useState([])
  const [loadingUsers, setLoadingUsers] = useState(false)

  const getUserList = async (page = 1) => {
    setLoadingUsers(true)
    try {
      const response = await NotificationsApi.getUserList(searchTerm, page, limit)
      const data = response?.rows || []

      const formatted = data.map(user => ({
        title: user.name || user.id,
        value: user.id,
      }))

      if (page === 1) {
        setOptions(formatted)
      } else {
        setOptions(prev => [...prev, ...formatted])
      }
    } catch (error) {
      console.error('Failed to fetch user list', error)
    } finally {
      setLoadingUsers(false)
    }
  }

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      getUserList(currentPage)
    }, 1000)
    return () => clearTimeout(delayDebounce)
  }, [searchTerm, currentPage])


  const handleChangeUser = (name) => {
    const selected = options.find(opt => opt.title === name)
    if (!selected) return

    const isSelected = user.includes(name)

    if (isSelected) {
      setUser(user.filter(u => u !== name))
      setSelectedIds(selectedIds.filter(id => id !== selected.value))
    } else {
      setUser([...user, name])
      setSelectedIds([...selectedIds, selected.value])
    }
  }

  useEffect(() => {
    if (isSelectAllUser) {
      setTimeout(() => {
        setUser(options.map(o => o.title))
        setSelectedIds(options.map(o => o.value))
      }, 1000);
    } else {
      setUser([])
      setSelectedIds([])
    }
  }, [isSelectAllUser])


  return (
    <div className={styles.notificationRow}>
      <div className={styles.notificationsNew}>
        <div className={styles.bigTitle}>Send Notification</div>

        <Formik
          validateOnBlur={false}
          validateOnChange={false}
          initialValues={{ message: '' }}
          validationSchema={VALIDATIONS.addNotificationSchema}
          onSubmit={async (values, { setSubmitting }) => {
            if (!isSelectAllUser && selectedIds.length === 0) {
              dispatch(showAlertAction('Please select at least one user or enable "Select All Users"'))
              return
            }

            const payload = {
              message: values.message,
              is_all: isSelectAllUser,
              user_ids: isSelectAllUser ? [] : selectedIds,
            }

            try {
              await NotificationsApi.sendNotification(payload)
              dispatch(showAlertAction('Notification sent successfully!'))
              setUser([])
              setSelectedIds([])
              setIsSelectAllUser(false)
              history.push('/notifications');
            } catch (err) {
              console.error(err)
              dispatch(showAlertAction('Failed to send notification'))
            } finally {
              setSubmitting(false)
            }
          }}
        >
          {({ errors, values, handleSubmit, handleChange, isSubmitting, setFieldError }) => (
            <form
              id='createAdminForm'
              onSubmit={handleSubmit}
              className={styles.addNotification}
            >
              <Input
                formHelper
                type='message'
                label='Message'
                name='message'
                placeholder='Enter message'
                value={values.message}
                error={errors.message}
                onChange={(e) => {
                  handleChange(e)
                  setFieldError('message', '')
                }}
                handleDelete
              />

              <div className={styles.title}>
                <input
                  type="checkbox"
                  checked={isSelectAllUser}
                  onChange={(e) => setIsSelectAllUser(e.target.checked)}
                /> Select All Users
              </div>

              <div className={styles.selectCase}>
                <CustomMultiSelectInput
                  options={options}
                  span={user}
                  onChange={setUser}
                  onChangeHandle={handleChangeUser}
                  placeholder='Choose Users'
                  disabled={isSelectAllUser}
                  searchValue={searchTerm}
                  loadingUsers={loadingUsers}
                  onSearchChange={(val) => {
                    setSearchTerm(val)
                    setCurrentPage(1)
                    setHasMore(true)
                  }}
                  fetchMoreOnScroll={() => {
                    if (!loadingUsers && hasMore) {
                      setCurrentPage(prev => prev + 1)
                    }
                  }}
                />
              </div>

              {isSubmitting ? (
                <div className={styles.addNotification__loader}>
                  <Loader />
                </div>
              ) : (
                <div className={styles.createBtnCase}>
                  <Button type='submit'>
                    <span>Send Notification</span>
                  </Button>
                </div>
              )}
            </form>
          )}
        </Formik>
      </div>
    </div>
  )
}

export default AddNotifications
